import { render } from "./pay-salary.vue?vue&type=template&id=60f08134"
import script from "./pay-salary.vue?vue&type=script&lang=js"
export * from "./pay-salary.vue?vue&type=script&lang=js"

import "./pay-salary.vue?vue&type=style&index=0&id=60f08134&lang=css"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__